<div id="config-reset-password-container" *ngIf="this.value">
  <p class="heading-02-semi-bold">
    Se creará una contraseña automática y se enviará por email al usuario:
  </p>
  <br />
  <p class="heading-02-bold">{{ this.value.email }}</p>
</div>
